import type { ReactNode } from "react";
import Toggle from "../Toggle/Toggle";
import "./Switch.css";

export interface SwitchProps {
  id: string;
  label: ReactNode;
  /** grey text under the row */
  description?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** anything after the description, e.g. a link or extra fields */
  children?: ReactNode;
}

/**
 * On/off setting row.
 * Example: <Switch id="dea" label="DEA rules" checked={on} onChange={setOn} />
 */
const Switch = ({
  id,
  label,
  description,
  checked,
  onChange,
  disabled = false,
  children,
}: SwitchProps) => (
  <div className="ds-switch">
    <div className="ds-switch__row">
      <label className="ds-switch__label" htmlFor={id}>
        {label}
      </label>
      <Toggle
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
    {description && <p className="ds-switch__description">{description}</p>}
    {children}
  </div>
);

export default Switch;
